function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00065 15.0116C4.31875 15.0116 1.33398 12.0268 1.33398 8.34489C1.33398 4.66299 4.31875 1.67822 8.00065 1.67822C11.6825 1.67822 14.6673 4.66299 14.6673 8.34489C14.6633 12.0251 11.6809 15.0075 8.00065 15.0116ZM2.66732 8.45956C2.69886 11.3937 5.09472 13.7513 8.02901 13.7356C10.9633 13.7197 13.3337 11.3366 13.3337 8.40222C13.3337 5.46789 10.9633 3.08474 8.02901 3.06889C5.09472 3.05319 2.69886 5.41073 2.66732 8.34489V8.45956ZM9.33398 11.6782H7.33398V9.01156H6.66732V7.67822H8.66732V10.3449H9.33398V11.6782ZM8.66732 6.34489H7.33398V5.01156H8.66732V6.34489Z",
  fill: "#B6B9BB"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5e3d4d3c.svg";
export { ForwardRef as ReactComponent };